<template>
  <div class="auth-detail-box">
    <div class="content" v-if="!loading">
      <div v-if="type==2">
        <div class="part-line" />
        <div class="part-title">企业信息</div>
        <div class="info-item">
          <div class="item-label">
            <span class="icon"></span>
            <span class="name">企业名称</span>
          </div>
          <div class="item-value">{{enterPriseInfo.companyName}}</div>
        </div>
        <div class="info-item">
          <div class="item-label">
            <span class="icon"></span>
            <span class="name">认证类型</span>
          </div>
          <div class="item-value">{{authTypeEnum[enterPriseInfo.authType]}}</div>
        </div>
        <template v-if="enterPriseInfo.authType=='1'">
          <div class="info-item">
            <div class="item-label">
              <span class="icon"></span>
              <span class="name">营业执照号</span>
            </div>
            <div class="item-value">{{enterPriseInfo.businessLicense}}</div>
          </div>
          <div class="info-item">
            <div class="item-label">
              <span class="icon"></span>
              <span class="name"></span>
            </div>
            <div class="item-value">
              <UploadImg v-model="enterPriseInfo.imgType1" :grade="'2'" :maxCount="1" :deletable="false" :isArray="false"/>
            </div>
          </div>
          <div class="info-item">
            <div class="item-label">
              <span class="icon"></span>
              <span class="name">组织机构代码</span>
            </div>
            <div class="item-value">{{enterPriseInfo.organizationCode}}</div>
          </div>
          <div class="info-item">
            <div class="item-label">
              <span class="icon"></span>
              <span class="name"></span>
            </div>
            <div class="item-value">
              <UploadImg v-model="enterPriseInfo.imgType2" :grade="'2'" :maxCount="1" :deletable="false" :isArray="false"/>
            </div>
          </div>
          <div class="info-item">
            <div class="item-label">
              <span class="icon"></span>
              <span class="name">税务登记证</span>
            </div>
            <div class="item-value">{{enterPriseInfo.taxRegister}}</div>
          </div>
          <div class="info-item">
            <div class="item-label">
              <span class="icon"></span>
              <span class="name"></span>
            </div>
            <div class="item-value">
              <UploadImg v-model="enterPriseInfo.imgType3" :grade="'2'" :maxCount="1" :deletable="false" :isArray="false"/>
            </div>
          </div>
        </template>
        <template v-if="enterPriseInfo.authType=='2'">
          <div class="info-item">
            <div class="item-label">
              <span class="icon"></span>
              <span class="name">统一社会信用代码</span>
            </div>
            <div class="item-value">{{enterPriseInfo.uniCredit}}</div>
          </div>
          <div class="info-item">
            <div class="item-label">
              <span class="icon"></span>
              <span class="name"></span>
            </div>
            <div class="item-value">
              <UploadImg v-model="enterPriseInfo.imgType1" :grade="'2'" :maxCount="1" :deletable="false" :isArray="false"/>
            </div>
          </div>
        </template>
        <div class="part-line" />
        <div class="part-title">法人信息</div>
        <div class="info-item">
          <div class="item-label">
            <span class="icon"></span>
            <span class="name">法人姓名</span>
          </div>
          <div class="item-value">{{enterPriseInfo.iegalName}}</div>
        </div>
        <div class="info-item">
          <div class="item-label">
            <span class="icon"></span>
            <span class="name">法人手机号</span>
          </div>
          <div class="item-value">{{enterPriseInfo.iegalPhone}}</div>
        </div>
        <div class="info-item">
          <div class="item-label">
            <span class="icon"></span>
            <span class="name">法人身份证</span>
          </div>
          <div class="item-value">
              <UploadImg v-model="enterPriseInfo.imgType8" :grade="'2'" :maxCount="1" :deletable="false" :isArray="false"/>
              <UploadImg v-model="enterPriseInfo.imgType9" :grade="'2'" :maxCount="1" :deletable="false" :isArray="false"/>
          </div>
        </div>
        <div class="part-line" />
        <div class="part-title">账户信息</div>
        <div class="info-item">
          <div class="item-label">
            <span class="icon"></span>
            <span class="name">企业对公账户</span>
          </div>
          <div class="item-value">{{enterPriseInfo.accountNo}}</div>
        </div>
        <div class="info-item">
          <div class="item-label">
            <span class="icon"></span>
            <span class="name">开户银行名称</span>
          </div>
          <div class="item-value">{{enterPriseInfo.parentBankName}}</div>
        </div>
        <div class="info-item">
          <div class="item-label">
            <span class="icon"></span>
            <span class="name">开户支行名称</span>
          </div>
          <div class="item-value">{{enterPriseInfo.bankName}}</div>
        </div>
        <div class="info-item">
          <div class="item-label">
            <span class="icon"></span>
            <span class="name">开户行行号</span>
          </div>
          <div class="item-value">{{enterPriseInfo.unionBank}}</div>
        </div>
        <template v-if="!isShowBindBank">
          <div class="info-item">
            <div class="item-label">
              <span class="icon"></span>
              <span class="name">绑定手机号</span>
            </div>
            <div class="item-value">{{enterPriseData.bankPhone}}</div>
          </div>
          <div class="info-item">
            <div class="item-label">
              <span class="icon"></span>
              <span class="name">个人银行卡号</span>
            </div>
            <div class="item-value">{{enterPriseData.bankCardNo}}</div>
          </div>
          <div class="info-item">
            <div class="item-label">
              <span class="icon"></span>
              <span class="name">持卡人姓名</span>
            </div>
            <div class="item-value">{{enterPriseData.bankName}}</div>
          </div>
          <div class="info-item">
            <div class="item-label">
              <span class="icon"></span>
              <span class="name">持卡人身份证号</span>
            </div>
            <div class="item-value">{{enterPriseData.bankIdentityNo}}</div>
          </div>
        </template>
      </div>
      <div v-else>
        <div class="info-item">
          <div class="item-label">
            <span class="icon"></span>
            <span class="name">真实姓名</span>
          </div>
          <div class="item-value">{{personalInfo.name}}</div>
        </div>
        <div class="info-item">
          <div class="item-label">
            <span class="icon"></span>
            <span class="name">身份证号</span>
          </div>
          <div class="item-value">{{personalInfo.identityNo}}</div>
        </div>
        <div class="info-item" v-if="!isShowBindBank">
          <div class="item-label">
            <span class="icon"></span>
            <span class="name">银行卡号</span>
          </div>
          <div class="item-value">{{personalData.bankCardNo}}</div>
        </div>
        <div class="info-item">
          <div class="item-label">
            <span class="icon"></span>
            <span class="name">联系电话</span>
          </div>
          <div class="item-value">{{personalInfo.phone || personalInfo.telephone}}</div>
        </div>
      </div>
      <div class="action-btns">
        <van-button
          v-if="isShowBindBank"
          style="marginRight:6px"
          @click="toBindCard"
          class="btn1"
        >绑定个人银行卡</van-button>
        <van-button @click="toClose" class="btn2">关闭</van-button>
      </div>
    </div>
    <div class="load-box" v-if="loading">
      <van-loading type="spinner" />
    </div>
  </div>
</template>

<script>
import { 
  getUserQfRegisterInfo,
  getInfoById,
  getEnterpriseInfo
} from '@/api/user';
import UploadImg from './components/upload.vue';
export default {
  components: {
    UploadImg
  },
  data() {
    return {
      loading: false,
      type: null, // 2企业 3个人
      personalInfo: {}, // 个人信息
      personalData: {},
      enterPriseInfo: {}, // 企业信息
      enterPriseData: {},
      // isShowEnterPriseBindBank: true, // 是否展示绑定银行卡按钮
      // isShowPersonalBindBank: true, // 是否展示绑定银行卡按钮
      isShowBindBank: true, // 是否展示绑定银行卡按钮
      authTypeEnum: ['', '三证', '一证'],
    }
  },
  created() {
    this.loading = true;
    getUserQfRegisterInfo().then(res => {
      if (res.code === 200) {
        // userType为【0管理员1分销商员工】 userType为【2分销员】
        // classify 1企业 2个人
        let userInfo_v2 = JSON.parse(localStorage.userInfo_v2);
        if (res.data.userType == '0' || res.data.userType == '1') {
          if (res.data.classify == '1') {
            this.type = 2;
            this.getEnterpriseInfo();
          } else if (res.data.classify == '2') {
            this.type = 3;
            this.getInfoById(userInfo_v2.identity.distributorId);
          }
        } else if (res.data.userType == '2') {
          this.type = 3;
          this.getInfoById(userInfo_v2.user.userId);
        }
      }
    }).catch(() => {
      this.loading = false;
    })
  },
  methods: {
    getInfoById(tempId) {
      getInfoById(tempId).then(res => {
        if (res.code === 200) {
          this.personalData = res.data;
          this.personalInfo = { ...res.data.user };
          // 已绑定银行卡
          if (res.data.isBindCard == '1') {
            this.isShowBindBank = false;
          } else {
            this.isShowBindBank = true;
          }
        }
        this.loading = false;
      }).catch(() => {
        this.personalInfo = {};
        this.personalData = {};
        this.loading = false;
      })
    },
    getEnterpriseInfo() {
      let userInfo_v2 = JSON.parse(localStorage.userInfo_v2);
      getEnterpriseInfo(userInfo_v2.identity.distributorId).then(res => {
        if (res.code === 200) {
          this.enterPriseData = res.data;
          this.enterPriseInfo = { ...res.data.company };
          // 已经绑定银行卡
          if (res.data.isBindCard == '1') {
            this.isShowBindBank = false;
          } else {
            this.isShowBindBank = true;
          }
          this.loading = false;
        }
      }).catch(() => {
        this.enterPriseData = {};
        this.enterPriseInfo = {};
        this.loading = false;
      })
    },
    toBindCard() {
      this.$router.push({
        path: "/bindBank",
        query: {
          type: this.type,
          isSuccess: false
        }  
      });
    },
    toClose() {
      this.$router.push({
        path: '/person'
      })
    },
  }
}
</script>
<style lang="scss" scoped>
.auth-detail-box {
  height: 100%;
  .content {
    padding: vw(60) vw(30) vw(60) vw(30);
    .info-item {
      display: flex;
      align-items: flex-start;
      font-size: vw(30);
      margin-bottom: vw(60);
      .item-label {
        flex: 2;
        // text-align: right;
        .icon {
          color: #D9001B;
        }
      }
      .item-value {
        flex: 4;
        margin-left: vw(14);
      }
    }
    .action-btns {
      text-align: center;
      margin-top: vw(60);
      .btn1 {
        border-radius: vw(8);
        border: 1px solid #3377FF;
        color: #3377FF;
      }
      .btn2 {
        border-radius: vw(8);
        border: 1px solid #C2C5CC;
        color: #333333;
      }
    }
    .part-line {
      height: vw(20);
      background: #F4F6F9;
      margin-left: vw(-30);
      margin-right: vw(-30);
    }
    .part-title {
      // border-bottom: 1px solid #F4F6F9;
      font-size: vw(32);
      color: #333333;
      padding: vw(30);
      margin: 0 vw(-30);
      font-weight: bold;
    }
  }
  .load-box {
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
  }
}
</style>